import { useTranslation } from "react-i18next";
import PlaceDataUtils from "../../utils/PlaceDataUtils";
import "./PlaceCategoryBadgeNoAmplify.css";

interface PlaceCategoryBadgeNoAmplifyProps {
    categoryEnum: string;
}

const PlaceCategoryBadgeNoAmplify: React.FC<PlaceCategoryBadgeNoAmplifyProps> = ({ categoryEnum }) => {
    const { t } = useTranslation();
    const categoryIcon = PlaceDataUtils.getPlaceCategoryDetail(categoryEnum)?.iconPath;

    return (
        <div className="place-category-badge-no-amplify">
            <div className="place-category-badge-content">
                <img 
                    src={categoryIcon} 
                    alt="" 
                    className="place-category-badge-icon"
                />
                <span className="place-category-badge-text">
                    {t('place.categories.' + categoryEnum)}
                </span>
            </div>
        </div>
    );
};

export default PlaceCategoryBadgeNoAmplify; 